import { render, staticRenderFns } from "./Advanced.vue?vue&type=template&id=2bfd7800&scoped=true"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"
import style0 from "./Advanced.vue?vue&type=style&index=0&id=2bfd7800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfd7800",
  null
  
)

export default component.exports